// Port de app/(tabs)/arquivos.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const ArquivosScreen = lazy(() => import("@/screens/Arquivos"));

export default function Arquivos() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <ArquivosScreen />
    </Carregando>
  ) : null;
}
